import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../core/store';
import { defaultRedirectPath } from '../../shared/consts/auth.consts';
import { isNotNullOrUndefined } from '../../shared/helpers/is-not-null-or-undefined/is-not-null-or-undefined.helpers';
import { AuthService } from '../services/auth.service';
import * as fromStore from '../store';

/**
 * @deprecated
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const store = inject(Store);

  const profile = authService.profile;

  /**
   * NOTE: a valid token is not enough — without a profile the app has no user
   * data to work with, and no endpoint can fetch one for an existing session.
   */
  if (authService.isAuthenticated && isNotNullOrUndefined(profile)) {
    // NOTE: perform some actions before proceeding
    store.dispatch(fromStore.fetchProfile({ payload: profile }));

    return true;
  }

  /**
   * NOTE: a valid token with no profile is unrecoverable — no endpoint refetches
   * a profile for an existing session — so it has to go through teardown rather
   * than to `/login`, where `checkAuthenticatedGuard` would bounce it back here
   * on the still-valid token. `/logout` is deliberately unguarded so this lands.
   */
  if (authService.isAuthenticated) {
    store.dispatch(
      fromRoot.go({ payload: { path: [defaultRedirectPath.logout] } }),
    );

    return false;
  }

  store.dispatch(
    fromRoot.go({
      payload: {
        path: ['login'],
        ...((
          ['/404', defaultRedirectPath.logout].every(
            (url) => !state.url.startsWith(url),
          )
        ) ?
          {
            query: {
              next: state.url,
            },
          }
        : {}),
      },
    }),
  );

  return false;
};
